<template>
  <div class="dark-premium-page">
    <!-- Start Header Area -->
    <Header>
      <img slot="logo" :src="logo" />
    </Header>
    <!-- End Header Area -->

    <!-- Start Breadcrump Area  -->
    <div
      class="rn-page-title-area pt--40 pb--80 hero-section-dark"
      data-black-overlay="5"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center rn-page-title pt--100">
              <h1 class="heading-title" style="color: white;">
                Automação de Processos e Robôs (RPA) em Navegantes
              </h1>
              <p style="color: rgba(255, 255, 255, 0.9);">
                Emissão automática de CT-e, averbação de carga e robôs fiscais. Criamos robôs que integram seus sistemas e automatizam tarefas manuais 24/7.
              </p>
              <div class="mt--40">
                <a
                  class="btn-default btn-border btn-large p-2"
                  href="https://wa.me/5547933807051"
                  target="_blank"
                  rel="noopener"
                >
                  <span>AUTOMATIZAR MINHA EMPRESA</span>
                </a>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <div class="rn-service-details ptb--120 service-section-dark">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="service-details-inner">
              <div class="inner">
                <!-- Start Single Content  -->
                <v-row class="sercice-details-content align-center row--35">
                  <v-col lg="12" md="12" cols="12">
                    <div class="details">
                      <div class="section-title text-center">
                        <span class="subtitle">Para seu negócio</span>
                        <h2 class="heading-title">
                          Soluções para o seu Negócio
                        </h2>
                        <p class="description" style="max-width: 700px; margin: 20px auto;">
                          Emissão automática de CT-e, averbação de carga e robôs fiscais.
                          Nossos robôs trabalham 24/7 integrando seus sistemas e processando dados com
                          zero erros. Foco em logística, transporte e operações portuárias.
                        </p>
                      </div>
                      
                      <!-- Cards Grid -->
                      <v-row class="mt--40">
                        <v-col lg="4" md="6" cols="12" v-for="(item, i) in businessFeatures" :key="i" class="mb--30">
                          <div class="premium-benefit-card">
                            <div class="benefit-icon" v-html="iconSvg(item.icon)"></div>
                            <h4 class="benefit-title">{{ item.title }}</h4>
                            <p class="benefit-text">{{ item.description }}</p>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
                <!-- End Single Content  -->
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="rn-service-details ptb--120 section-dark">
      <v-container>
        <!-- Start Single Content  -->
        <v-row class="align-center row--35">
          <v-col cols="12">
            <div class="text-center section-title mb--60">
              <span class="subtitle">Resultados</span>
              <h2 class="heading-title">Benefícios Reais para Seu Negócio</h2>
              <p class="description" style="max-width: 700px; margin: 20px auto 0;">
                Nossa automação vai além de economizar tempo. Entregamos soluções que
                eliminam erros, reduzem custos e liberam sua equipe para atividades estratégicas.
              </p>
            </div>
          </v-col>
        </v-row>
        
        <v-row class="mt--20">
          <v-col lg="4" md="6" cols="12" v-for="(item, i) in benefitsList" :key="i" class="mb--30">
            <div class="premium-benefit-card">
              <div class="benefit-icon-wrapper">
                <div class="benefit-icon" v-html="iconSvg(item.icon)"></div>
              </div>
              <h4 class="benefit-title">{{ item.title }}</h4>
              <p class="benefit-text">{{ item.text }}</p>
            </div>
          </v-col>
        </v-row>
        <!-- End Single Content  -->
      </v-container>
    </div>

    <!-- Start Technologies Section (Secondary) -->
    <div class="rn-service-details ptb--80 tech-section-dark">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center section-title mb--50">
              <span class="subtitle">Tecnologias que dominamos</span>
              <h3 class="heading-title" style="font-size: 28px;">
                Para garantir sua segurança e performance
              </h3>
              <p class="description" style="max-width: 650px; margin: 15px auto 0;">
                Trabalhamos com as melhores plataformas de automação e integração do mercado para
                entregar soluções robustas e confiáveis
              </p>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            lg="4"
            md="6"
            cols="12"
            v-for="(tech, i) in techBenefits"
            :key="i"
            class="mb--30"
          >
            <div class="premium-tech-card">
              <div class="tech-benefit-title">{{ tech.title }}</div>
              <div class="tech-benefit-desc">{{ tech.description }}</div>
              <div class="tech-benefit-tags">
                <span
                  class="tech-tag-premium"
                  v-for="(tag, idx) in tech.tags"
                  :key="idx"
                  >{{ tag }}</span
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Technologies Section -->

    <!-- Start CTA Area -->
    <div
      class="call-to-action-wrapper call-to-action call-to-action-two text-white-wrapper ptb--120 bg_image bg_image--1"
      data-black-overlay="7"
    >
      <v-container>
        <v-row>
          <v-col lg="10" offset-lg="1" cols="12">
            <div class="inner text-center">
              <h2 class="heading-title">
                Pronto para Automatizar sua Empresa e Eliminar Erros?
              </h2>
              <p class="description">
                Vamos conversar sobre como a automação pode transformar seus processos
                e liberar sua equipe para o que realmente importa em Navegantes.
              </p>
              <a
                class="btn-default btn-border btn-large btn-white mt--40"
                href="https://wa.me/5547933807051"
                target="_blank"
                rel="noopener"
              >
                <span>AGENDAR CONVERSA</span>
              </a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End CTA Area -->

    <!-- Start Atendimento Local Area -->
    <div class="rn-service-details ptb--120 section-dark">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center section-title mb--50">
              <span class="subtitle">Proximidade</span>
              <h2 class="heading-title">Atendimento Local</h2>
              <p class="description">
                Estamos próximos para reuniões presenciais e acompanhamento
                próximo do seu projeto.
              </p>
            </div>
          </v-col>
        </v-row>
        <v-row class="align-center">
          <v-col lg="6" md="6" cols="12" class="mb_md--30 mb_sm--30">
            <div class="local-info">
              <div class="section-title text-left">
                <h3 class="heading-title mb--20">Nossa Localização</h3>
                <p class="description">
                  Rua José Luiz Marcelino, 62 - Murta<br />
                  Itajaí - SC
                </p>
                <div class="mt--30">
                  <a
                    href="https://wa.me/5547933807051"
                    class="btn-default"
                    target="_blank"
                    rel="noopener"
                  >
                    TOMAR UM CAFÉ
                  </a>
                </div>
              </div>
            </div>
          </v-col>
          <v-col lg="6" md="6" cols="12">
            <div class="google-map rn-contact-map-area position-relative">
              <div class="mapouter">
                <div class="gmap_canvas">
                  <iframe
                    id="gmap_canvas_local"
                    src="https://maps.google.com/maps?q=Rua+José+Luiz+Marcelino,+62+-+Murta,+Itajaí+-+SC&t=&z=15&ie=UTF8&iwloc=&output=embed"
                    frameborder="0"
                    scrolling="no"
                    marginheight="0"
                    marginwidth="0"
                    class="map-grayscale"
                  ></iframe>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Atendimento Local Area -->

    <!-- Start Footer Area -->
    <Footer />
    <!-- End Footer Area -->
  </div>
</template>

<script>
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import feather from "feather-icons";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      logo: "/logoCodetimeWhite.webp",
      businessFeatures: [
        {
          icon: "file-text",
          title: "Emissão de CT-e",
          description: "Emissão automática de CT-e e documentos fiscais para transporte."
        },
        {
          icon: "check-circle",
          title: "Averbação de Carga",
          description: "Averbação automática de carga e processos portuários."
        },
        {
          icon: "shield",
          title: "Robôs Fiscais",
          description: "Robôs que automatizam processos fiscais e tributários."
        },
        {
          icon: "zap",
          title: "Velocidade Máxima",
          description: "Processos que levavam horas agora feitos em segundos."
        },
      ],
      benefitsList: [
        {
          icon: "file-text",
          title: "Emissão de CT-e",
          text:
            "Emissão automática de CT-e e documentos fiscais para transporte. Zero erros, 100% de confiabilidade.",
        },
        {
          icon: "check-circle",
          title: "Averbação de Carga",
          text:
            "Averbação automática de carga e processos portuários. Tudo integrado e funcionando.",
        },
        {
          icon: "shield",
          title: "Robôs Fiscais",
          text:
            "Robôs que automatizam processos fiscais e tributários, eliminando erros e ganhando tempo.",
        },
        {
          icon: "zap",
          title: "Velocidade Máxima",
          text:
            "Processos que levavam horas agora feitos em segundos. Sua operação nunca foi tão rápida.",
        },
        {
          icon: "dollar-sign",
          title: "Redução de Custos",
          text:
            "Libere sua equipe talentosa para pensar, deixe o robô fazer o trabalho chato. Economia real de tempo e dinheiro.",
        },
        {
          icon: "clock",
          title: "Disponibilidade 24/7",
          text:
            "Robôs que trabalham enquanto você dorme. Processos rodando 24 horas por dia, 7 dias por semana.",
        },
        {
          icon: "trending-up",
          title: "Escalabilidade",
          text:
            "Sua automação cresce junto com sua empresa, sem limites de volume ou complexidade.",
        },
      ],
      visualBenefits: [
        { icon: "file-text", name: "CT-e" },
        { icon: "check-circle", name: "Averbação" },
        { icon: "shield", name: "Fiscal" },
        { icon: "zap", name: "Velocidade" },
        { icon: "clock", name: "24/7" },
        { icon: "trending-up", name: "Escalável" },
      ],
      techBenefits: [
        {
          title: "RPA e Automação",
          description:
            "Robôs que replicam ações humanas com precisão. Automação de processos repetitivos sem erros.",
          tags: ["RPA", "UiPath", "Automation Anywhere"],
        },
        {
          title: "Integração de Sistemas",
          description:
            "Conectamos seus sistemas sem precisar trocar nada. APIs e integrações que funcionam perfeitamente.",
          tags: ["APIs REST", "Webhooks", "Integração"],
        },
        {
          title: "Processamento de Dados",
          description:
            "Processamento rápido e confiável de grandes volumes de dados. ETL e transformação de dados automatizada.",
          tags: ["ETL", "Data Processing", "Python"],
        },
      ],
    };
  },
  mounted() {
    // Adiciona JSON-LD Schema.org LocalBusiness
    this.addJsonLd();
    // Adiciona meta description dinamicamente
    this.addMetaDescription();
  },
  methods: {
    iconSvg(icon) {
      if (feather.icons[icon]) {
        return feather.icons[icon].toSvg();
      }
      return feather.icons["box"].toSvg();
    },
    addJsonLd() {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id":
          "https://codetime.com.br/servicos/automacao-processos-navegantes#organization",
        "name": "Codetime Sistemas",
        "alternateName": "Codetime",
        "description":
          "Empresa especializada em automação de processos e RPA em Navegantes, SC. Emissão automática de CT-e, averbação de carga e robôs fiscais para logística e transporte.",
        "url": "https://codetime.com.br",
        "logo": "https://codetime.com.br/logoCodetimeWhite.webp",
        "image": "https://codetime.com.br/logoCodetimeWhite.webp",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Rua José Luiz Marcelino, 62 - Murta",
          "addressLocality": "Itajaí",
          "addressRegion": "SC",
          "postalCode": "88308-545",
          "addressCountry": "BR",
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": -26.9078,
          "longitude": -48.6619,
        },
        "telephone": "+5547933807051",
        "email": "contato@codetime.com.br",
        "priceRange": "$$",
        "areaServed": [
          {
            "@type": "City",
            "name": "Navegantes",
          },
          {
            "@type": "State",
            "name": "Santa Catarina",
          },
        ],
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
          ],
          "opens": "08:00",
          "closes": "18:00",
        },
        "sameAs": [
          "https://www.instagram.com/codetime_sistemas/",
          "https://www.linkedin.com/company/codetime-sistemas",
          "https://maps.app.goo.gl/c9fW8Q9jdct8iYG56",
        ],
        "knowsAbout": [
          "Automação de Processos",
          "RPA - Robotic Process Automation",
          "Emissão de CT-e",
          "Averbação de Carga",
          "Robôs Fiscais",
          "ETL",
        ],
      });
      document.head.appendChild(script);
    },
    addMetaDescription() {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      metaDescription.content =
        "Automação de processos e RPA em Navegantes, SC. Emissão automática de CT-e, averbação de carga e robôs fiscais. Robôs que trabalham 24/7 eliminando erros.";
    },
  },
};
</script>

<style lang="scss" scoped>
/* Estilos para a logo - manter consistente com outras páginas */
.dark-premium-page .default-header .logo img,
.dark-premium-page .logo img,
.default-header .logo img,
.logo img {
  max-height: 30px !important;
  height: 30px !important;
  width: auto !important;
  object-fit: contain;
}

@media (max-width: 959px) {
  .dark-premium-page .default-header .logo img,
  .dark-premium-page .logo img,
  .default-header .logo img,
  .logo img {
    max-height: 30px !important;
    height: 30px !important;
  }
}

/* Fundo escuro global da página */
.dark-premium-page {
  background: #020617; /* slate-950 */
  min-height: 100vh;
}

/* Hero Section Dark */
.hero-section-dark {
  position: relative;
  background: linear-gradient(160deg, #08090d 0%, #0a0b12 40%, #0a0f18 100%);
  overflow: hidden;
}

.hero-section-dark::before {
  content: "";
  position: absolute;
  inset: -10% -10% -10% -10%;
  background:
    radial-gradient(700px 360px at 20% 20%, rgba(0, 140, 247, 0.12), transparent 62%),
    radial-gradient(680px 360px at 80% 70%, rgba(249, 93, 129, 0.10), transparent 64%);
  pointer-events: none;
  z-index: 0;
}

.hero-section-dark > .v-container {
  position: relative;
  z-index: 1;
}

/* Seção de Serviços Dark */
.service-section-dark {
  position: relative;
  background: linear-gradient(160deg, #0a0b10 0%, #0e1220 45%, #0a1424 100%);
  overflow: hidden;
}

.service-section-dark::before {
  content: "";
  position: absolute;
  inset: -10% -10% -10% -10%;
  background:
    radial-gradient(600px 320px at 15% 25%, rgba(0, 140, 247, 0.12), transparent 60%),
    radial-gradient(760px 420px at 85% 70%, rgba(249, 93, 129, 0.10), transparent 65%),
    radial-gradient(520px 300px at 70% 20%, rgba(118, 68, 255, 0.08), transparent 62%);
  filter: saturate(1.02);
  pointer-events: none;
  z-index: 0;
}

.service-section-dark > .v-container { position: relative; z-index: 1; }

/* Seções Dark */
.section-dark {
  position: relative;
  background: linear-gradient(160deg, #0b0c12 0%, #0c0f18 50%, #0b101a 100%);
  overflow: hidden;
}

.section-dark::before {
  content: "";
  position: absolute;
  inset: -10% -10% -10% -10%;
  background:
    radial-gradient(520px 260px at 75% 25%, rgba(249, 93, 129, 0.12), transparent 60%),
    radial-gradient(520px 260px at 25% 75%, rgba(118, 68, 255, 0.10), transparent 62%);
  pointer-events: none;
  z-index: 0;
}

.section-dark > .v-container { position: relative; z-index: 1; }

/* Seção de Tecnologias Dark */
.tech-section-dark {
  position: relative;
  background: linear-gradient(160deg, #0a0b10 0%, #0e1220 45%, #0a1424 100%);
  overflow: hidden;
}

.tech-section-dark::before {
  content: "";
  position: absolute;
  inset: -10% -10% -10% -10%;
  background:
    radial-gradient(520px 260px at 25% 30%, rgba(0, 140, 247, 0.10), transparent 62%),
    radial-gradient(520px 260px at 75% 70%, rgba(249, 93, 129, 0.10), transparent 62%);
  pointer-events: none;
  z-index: 0;
}

.tech-section-dark > .v-container { position: relative; z-index: 1; }

/* Premium Feature Cards - Dark */
.premium-feature-card {
  background: #0f172a; /* slate-900 */
  backdrop-filter: blur(10px);
  border: 1px solid #1e293b; /* slate-800 */
  border-radius: 16px;
  padding: 40px 30px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  height: 100%;
}

.premium-feature-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #008CF7 0%, #337DFF 100%);
  transform: scaleX(0);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: left;
}

.premium-feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 140, 247, 0.25);
  border-color: rgba(59, 130, 246, 0.5); /* blue-500/50 */
}

.premium-feature-card:hover::before {
  transform: scaleX(1);
}

.feature-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, rgba(0, 140, 247, 0.1) 0%, rgba(51, 125, 255, 0.1) 100%);
  border-radius: 12px;
  transition: all 0.4s ease;
}

.premium-feature-card:hover .feature-icon {
  background: linear-gradient(135deg, #008CF7 0%, #337DFF 100%);
  transform: scale(1.1) rotate(5deg);
}

.feature-icon svg {
  width: 32px;
  height: 32px;
  color: #3b82f6; /* blue-500 - mais visível no dark */
  stroke: #3b82f6;
  transition: all 0.4s ease;
}

.premium-feature-card:hover .feature-icon svg {
  color: #60a5fa; /* blue-400 - mais brilhante no hover */
  stroke: #60a5fa;
}

.feature-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
  transition: color 0.3s ease;
}

.premium-feature-card:hover .feature-title {
  color: #3b82f6; /* blue-500 */
}

.feature-desc {
  font-size: 14px;
  color: #e5e7eb; /* gray-200 - cinza bem claro */
  line-height: 1.6;
  margin: 0;
}

/* Premium Benefit Cards - Dark */
.premium-benefit-card {
  background: #0f172a; /* slate-900 */
  border: 1px solid #1e293b; /* slate-800 */
  border-radius: 16px;
  padding: 40px 30px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  position: relative;
  overflow: hidden;
  margin-bottom: 30px;
}

.premium-benefit-card::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  background: linear-gradient(135deg, rgba(0, 140, 247, 0.05) 0%, rgba(51, 125, 255, 0.05) 100%);
  transition: height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 0;
}

.premium-benefit-card:hover::after {
  height: 100%;
}

.premium-benefit-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 140, 247, 0.25);
  border-color: rgba(59, 130, 246, 0.5); /* blue-500/50 */
}

.benefit-icon-wrapper {
  position: relative;
  z-index: 1;
  margin-bottom: 20px;
}

.benefit-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #008CF7 0%, #337DFF 100%);
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 140, 247, 0.3);
  transition: all 0.4s ease;
}

.premium-benefit-card:hover .benefit-icon {
  transform: scale(1.1) rotate(-5deg);
  box-shadow: 0 12px 30px rgba(0, 140, 247, 0.4);
}

.benefit-icon svg {
  width: 28px;
  height: 28px;
  color: white;
}

.benefit-title {
  font-size: 19px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
  position: relative;
  z-index: 1;
}

.benefit-text {
  font-size: 14px;
  color: #e5e7eb; /* gray-200 - cinza bem claro */
  line-height: 1.7;
  margin: 0;
  position: relative;
  z-index: 1;
}

/* Premium Tech Cards - Dark */
.premium-tech-card {
  background: #0f172a; /* slate-900 */
  border: 1px solid #1e293b; /* slate-800 */
  border-radius: 16px;
  padding: 40px 30px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  position: relative;
  overflow: hidden;
  margin-bottom: 30px;
}

.premium-tech-card::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(0, 140, 247, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  transition: all 0.5s ease;
  opacity: 0;
}

.premium-tech-card:hover::before {
  opacity: 1;
  transform: translate(-20px, 20px);
}

.premium-tech-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 140, 247, 0.25);
  border-color: rgba(59, 130, 246, 0.5); /* blue-500/50 */
}

.tech-benefit-title {
  font-size: 19px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 15px;
  position: relative;
  z-index: 1;
}

.tech-benefit-desc {
  font-size: 14px;
  color: #e5e7eb; /* gray-200 - cinza bem claro */
  line-height: 1.7;
  margin-bottom: 22px;
  position: relative;
  z-index: 1;
}

.tech-benefit-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  position: relative;
  z-index: 1;
}

.tech-tag-premium {
  font-size: 11px;
  padding: 6px 14px;
  background: linear-gradient(135deg, #008CF7 0%, #337DFF 100%);
  border-radius: 20px;
  color: white;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 140, 247, 0.25);
}

.tech-tag-premium:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 140, 247, 0.35);
}

.local-info {
  padding: 20px;
}

.local-info .description {
  color: #e5e7eb !important; /* gray-200 - cinza bem claro */
}

.local-info .heading-title {
  color: #ffffff !important;
}

.mapouter {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.gmap_canvas {
  overflow: hidden;
  background: none !important;
  height: 400px;
  width: 100%;
}

.gmap_canvas iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

.map-grayscale {
  filter: grayscale(100%) brightness(0.7) contrast(1.1);
  transition: filter 0.3s ease;
}

.map-grayscale:hover {
  filter: grayscale(80%) brightness(0.75) contrast(1.05);
}

/* Títulos e textos dark - regras globais com alta especificidade */
.dark-premium-page .section-title p.description,
.dark-premium-page .section-title .description,
.dark-premium-page .section-title p,
.dark-premium-page .service-section-dark .section-title p,
.dark-premium-page .section-dark .section-title p,
.dark-premium-page .tech-section-dark .section-title p {
  color: #e5e7eb !important; /* gray-200 - cinza bem claro */
}

.dark-premium-page .section-title .heading-title,
.dark-premium-page .section-title h1,
.dark-premium-page .section-title h2,
.dark-premium-page .section-title h3,
.dark-premium-page .section-title h4,
.dark-premium-page .service-section-dark .section-title .heading-title,
.dark-premium-page .section-dark .section-title .heading-title,
.dark-premium-page .tech-section-dark .section-title .heading-title {
  color: #ffffff !important;
}

.dark-premium-page .section-title .subtitle,
.dark-premium-page .section-title span.subtitle {
  color: #d1d5db !important; /* gray-300 - cinza claro para subtítulos */
}

.dark-premium-page h1,
.dark-premium-page h2,
.dark-premium-page h3,
.dark-premium-page h4,
.dark-premium-page h5,
.dark-premium-page h6,
.dark-premium-page .heading-title {
  color: #ffffff !important;
}

.dark-premium-page p,
.dark-premium-page .description {
  color: #e5e7eb !important; /* gray-200 - cinza bem claro */
}

.dark-premium-page .subtitle,
.dark-premium-page span.subtitle {
  color: #d1d5db !important; /* gray-300 - cinza claro para subtítulos */
}

@media (max-width: 960px) {
  .service-section::before,
  .tech-section::before {
    width: 400px;
    height: 400px;
  }

  .premium-feature-card,
  .premium-benefit-card,
  .premium-tech-card {
    padding: 30px 20px;
    margin-bottom: 20px;
  }

  .gmap_canvas {
    height: 350px;
  }

  .local-info {
    text-align: center;
    padding: 0;
  }

  .local-info .section-title {
    text-align: center !important;
  }
}

@media (max-width: 600px) {
  .service-section-dark::before,
  .tech-section-dark::before,
  .section-dark::before {
    width: 300px;
    height: 300px;
  }

  .premium-feature-card,
  .premium-benefit-card {
    padding: 25px 18px;
  }

  .premium-tech-card {
    padding: 25px 18px;
  }

  .feature-icon,
  .benefit-icon {
    width: 55px;
    height: 55px;
  }

  .feature-icon svg,
  .benefit-icon svg {
    width: 26px;
    height: 26px;
  }

  .gmap_canvas {
    height: 300px;
  }
}
</style>
